module.exports = __webpack_public_path__ + "img/group1779.56dd7728.svg";